module.exports = __webpack_public_path__ + "static/img/user-propile-level02.a73cf85a.svg";